import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, Search, Menu, X, User, Heart } from "lucide-react";
import { BRAND, NAV_LINKS, ANNOUNCEMENTS } from "../mock";
import { useCart } from "../contexts/CartContext";

const Header = () => {
  const [announceIdx, setAnnounceIdx] = useState(0);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { totalQty, setIsOpen } = useCart();

  useEffect(() => {
    const t = setInterval(() => {
      setAnnounceIdx((i) => (i + 1) % ANNOUNCEMENTS.length);
    }, 3500);
    return () => clearInterval(t);
  }, []);

  return (
    <header className="sticky top-0 z-50">
      {/* Announcement bar */}
      <div className="bg-[#1A1410] text-[#FFF2EC] text-xs md:text-[13px] tracking-wider">
        <div className="max-w-7xl mx-auto px-4 h-9 flex items-center justify-center overflow-hidden relative">
          <div className="flex items-center gap-2 font-medium">
            <span className="hidden sm:inline w-1 h-1 rounded-full bg-[#DD4D2A]" />
            <span className="uppercase">{ANNOUNCEMENTS[announceIdx]}</span>
            <span className="hidden sm:inline w-1 h-1 rounded-full bg-[#DD4D2A]" />
          </div>
        </div>
      </div>

      {/* Main nav */}
      <div className="bg-[#FFF2EC]/95 backdrop-blur-md border-b border-[#1A1410]/10">
        <div className="max-w-7xl mx-auto px-4 h-16 md:h-20 flex items-center justify-between">
          <button
            className="md:hidden p-2 -ml-2"
            onClick={() => setMobileOpen(true)}
            aria-label="Open menu"
          >
            <Menu className="w-5 h-5" />
          </button>

          <nav className="hidden md:flex items-center gap-7 text-[13px] font-medium uppercase tracking-wider">
            {NAV_LINKS.slice(0, 3).map((l) => (
              <Link
                key={l.label}
                to={l.href}
                className="hover:text-[#DD4D2A] transition-colors"
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <Link to="/" className="flex flex-col items-center leading-none group">
            <span className="font-serif-display text-[32px] md:text-[42px] font-bold italic text-[#1A1410] tracking-tight group-hover:text-[#DD4D2A] transition-colors leading-none">
              GVB
            </span>
            <span className="font-display text-[9px] md:text-[10px] tracking-[0.35em] uppercase text-[#DD4D2A] mt-1">
              George Venture Brands
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-7 text-[13px] font-medium uppercase tracking-wider">
            {NAV_LINKS.slice(3).map((l) => (
              <Link
                key={l.label}
                to={l.href}
                className="hover:text-[#DD4D2A] transition-colors"
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-1 md:gap-2">
            <button
              aria-label="Search"
              className="p-2 hover:bg-[#1A1410]/5 rounded-full transition-colors"
            >
              <Search className="w-[18px] h-[18px]" />
            </button>
            <button
              aria-label="Account"
              className="p-2 hover:bg-[#1A1410]/5 rounded-full transition-colors hidden sm:flex"
            >
              <User className="w-[18px] h-[18px]" />
            </button>
            <button
              aria-label="Wishlist"
              className="p-2 hover:bg-[#1A1410]/5 rounded-full transition-colors hidden sm:flex"
            >
              <Heart className="w-[18px] h-[18px]" />
            </button>
            <button
              aria-label="Cart"
              onClick={() => setIsOpen(true)}
              className="relative p-2 hover:bg-[#1A1410]/5 rounded-full transition-colors"
            >
              <ShoppingBag className="w-[18px] h-[18px]" />
              {totalQty > 0 && (
                <span className="absolute -top-0.5 -right-0.5 bg-[#DD4D2A] text-white text-[10px] font-bold w-[18px] h-[18px] rounded-full flex items-center justify-center">
                  {totalQty}
                </span>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden fixed inset-0 z-50 bg-[#FFF2EC]">
          <div className="flex items-center justify-between h-16 px-4 border-b border-[#1A1410]/10">
            <span className="font-serif-display text-xl font-semibold">
              George Venture Brands
            </span>
            <button onClick={() => setMobileOpen(false)} aria-label="Close">
              <X className="w-5 h-5" />
            </button>
          </div>
          <nav className="p-6 flex flex-col gap-5 text-lg font-medium uppercase tracking-wider">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.label}
                to={l.href}
                onClick={() => setMobileOpen(false)}
                className="py-2 border-b border-[#1A1410]/10"
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
